module.exports = __webpack_public_path__ + "static/img/team-build-01.983441d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-01.jpg
// module id = 9qqj
// module chunks = 1